import { API } from "config";
import type { Task } from "types/Task";
import request from "utilities/request";

const baseUrl = API.dbApi.url;

export interface ClaimTerminalResult {
  /** Current row, or undefined when the row is gone (404). */
  task?: Task;
  /** True when this caller won the compare-and-set. */
  claimed: boolean;
  /** True when the row no longer exists; callers must not retry. */
  gone?: boolean;
}

/**
 * Sets `terminal_directive_injected_at` only when currently NULL. A second call
 * for the same row returns `claimed=false`. A 404 resolves to
 * `{ claimed: false, gone: true }` rather than throwing, so callers stop instead
 * of re-queuing a vanished row. (`request` throws on non-OK, so 404 is detected
 * via the thrown error's attached response.)
 */
export async function claimTerminalTask(
  id: string,
  getAccessToken: () => Promise<string>
): Promise<ClaimTerminalResult> {
  const accessToken = await getAccessToken();

  const url = `${baseUrl}/tasks/${id}/claim-terminal`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };
  const options = { method: "PATCH", headers };

  try {
    const response = await request(url, options);
    return (await response.json()) as ClaimTerminalResult;
  } catch (error: unknown) {
    const status = (error as { response?: Response })?.response?.status;
    if (status === 404) return { claimed: false, gone: true };
    throw error;
  }
}
